module.exports = __webpack_public_path__ + "img/sb_l.png?0c2fe14bf053971e7971b670b91d1724";